/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { ModelUtils } from '../util/ModelUtils';
import { Document } from '../../core/models/Document';
import { Oas20Document } from '../../openapi/v2/models/Oas20Document';
import { Oas20ResponseDefinition } from '../../openapi/v2/models/Oas20ResponseDefinition';
import { Oas20ResponseDefinitions } from '../../openapi/v2/models/Oas20ResponseDefinitions';
import { DeleteResponseDefinitionCommand } from './DeleteResponseDefinitionCommand';
import { Node } from '../../core/models/Node';

/**
 * @author eric.wittmann@gmail.com
 * @extends DeleteResponseDefinitionCommand
 * @class
 */
export class DeleteResponseDefinitionCommand_20 extends DeleteResponseDefinitionCommand {
    public constructor(definitionName? : any) {
        if(((typeof definitionName === 'string') || definitionName === null)) {
            let __args = arguments;
            super(definitionName);
        } else if(definitionName === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.DeleteResponseDefinitionCommand#doDeleteResponseDefinition(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     * @return {*}
     */
    doDeleteResponseDefinition(document : Document) : any {
        let doc20 : Oas20Document = <Oas20Document>document;
        let responses : Oas20ResponseDefinitions = doc20.responses;
        if(this.isNullOrUndefined(responses) || ModelUtils.isNullOrUndefined(responses.getResponse(this._definitionName))) {
            return null;
        }
        let schemaDef : Oas20ResponseDefinition = responses.removeResponse(this._definitionName);
        return Library.writeNode(schemaDef);
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.DeleteResponseDefinitionCommand#doRestoreResponseDefinition(io.apicurio.datamodels.core.models.Document, java.lang.Object)
     * @param {Document} document
     * @param {*} oldDefinition
     */
    doRestoreResponseDefinition(document : Document, oldDefinition : any) {
        let doc20 : Oas20Document = <Oas20Document>document;
        let responses : Oas20ResponseDefinitions = doc20.responses;
        if(this.isNullOrUndefined(responses)) {
            return;
        }
        let definition : Oas20ResponseDefinition = doc20.responses.createResponse(this._definitionName);
        Library.readNode(oldDefinition, definition);
        responses.addResponse(this._definitionName, definition);
    }
}
DeleteResponseDefinitionCommand_20["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteResponseDefinitionCommand_20";
DeleteResponseDefinitionCommand_20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




